import { cn } from "@edusogno/lib/utils";
import { Trans } from "react-i18next";
import { ArrowRight } from "lucide-react";
import Button from "@edusogno/primitives/button.js";
import NotificationIcon from "@/components/home/notifications/NotificationIcon.tsx";

interface NotificationItemProps {
  item: unknown;
}

const NotificationItem: React.FC<NotificationItemProps> = ({ item }) => {
  const {
    msg,
    ora,
    body,
    link,
    toNow,
    title,
    fromNow,
    lessonType,
    notificationType,
  } = item as never;

  const toNowString = toNow as string;

  const toTime = toNowString
    ?.replace(" ago", "")
    ?.replace(" fa", "")
    ?.replace("vor ", "");

  const getLessonType = () => {
    switch (lessonType) {
      case "Correction":
        return "Writing";
      default:
        return lessonType;
    }
  };

  const hour = ora as Date;

  if (hour <= new Date()) return null;

  return (
    <div
      className={cn(
        "rounded-md w-full min-h-[49px] items-center px-4 grid gap-4",
        {
          "grid-cols-[16px_auto_30px] bg-white": notificationType === 1,
          "grid-cols-[70px_auto_18px] bg-[--primary300]":
            notificationType === 0,
        },
      )}
    >
      <NotificationIcon
        variant={notificationType}
        lessonType={getLessonType()}
      />

      <p className="text-[10px] [&_i]:font-semibold [&_i]:not-italic text-secondary font-regular leading-[120%] py-1">
        <p className="mb-1">
          <b>{title}</b>
        </p>

        {notificationType === 0 ? (
          <Trans
            values={{
              timeToStart: toTime,
              period:
                (ora as { format: (str: string) => string })?.format("HH:mm") ??
                ("00:00" as string),
            }}
            i18nKey={body ? "" : "home.notification_class_start"} // optional -> fallbacks to defaults if not provided
            defaults={body ?? msg} // optional defaultValue
            components={{
              br: <br />,
              bold: <b className="font-semibold capitalize text-primary" />,
            }}
          />
        ) : (
          <div dangerouslySetInnerHTML={{ __html: body }} />
        )}
      </p>

      {notificationType === 1 ? (
        <p className="text-[--grey300] text-xs w-fit ml-auto">{fromNow}</p>
      ) : (
        <a href={link}>
          <Button variant="ghost" className="w-fit">
            <ArrowRight className="text-primary" />
          </Button>
        </a>
      )}
    </div>
  );
};

export default NotificationItem;
